var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoanForm',{attrs:{"selectedProduct":_vm.selectedProduct,"showEir":_vm.isShownEir,"showApr":_vm.isShownApr,"campaignText":_vm.$t('LoanFormPage.campaignConditionsNewCustomer')},on:{"submit":_vm.submitLoanApplication}})}
var staticRenderFns = []

export { render, staticRenderFns }